export interface PurchasedItem {
  id: string;
  name: string;
  price: number;
  quantity: number;
  imageUrl: string;
}

export enum ProviderEnum {
  STRIPE = 'stripe',
  ADYEN = 'adyen',
  BRAINTREE = 'braintree',
  NUVEI = 'nuvei',
  PAYPAL = 'paypal',
  /** Subscription flow only — Chargebee routes to the actual PSP gateway. */
  CHARGEBEE = 'chargebee',
}

export type ExcludeOtherPaymentMethod = Exclude<PaymentMethodEnum, PaymentMethodEnum.OTHER>;

export enum CardType {
  VISA = 'visa',
  MASTERCARD = 'mastercard',
  AMEX = 'amex',
  DISCOVER = 'discover',
  DINERS = 'diners',
}

export enum DeviceType {
  ANDROID = 'android',
  IOS = 'ios',
  WEB = 'web',
}

export enum PaymentMethodEnum {
  CREDIT_CARD = 'card',
  APPLE_PAY = 'apple',
  GOOGLE_PAY = 'google',
  OTHER = 'other',
  PAYPAL = 'paypal',
  CASH_APP = 'cashapp',
  KLARNA = 'klarna',
  LINK = 'link',
  UNIONPAY = 'unionpay',
  VERIFON = 'verifone',
  AMAZON_PAY = 'amazon_pay',
  VENMO = 'venmo',
  AFTERPAY = 'afterpay',
  IDEAL = 'ideal',
  AFFIRM = 'affirm',
  PIX = 'apmgw_PIX',
  NEOSURF = 'apmgw_Neosurf',
  BLIK = 'blik',
  BLIK_CHECKOUT = 'blik_checkout',
  P24 = 'p24',
  TRUSTLY = 'apmgw_Trustly',
  TOUCHNGO = 'apmgw_TouchnGo',
  EPS = 'eps',
  BANCONTACT = 'bancontact',
  BIZUM = 'bizum',
  ALIPAY = 'alipay_hk',
  PAYME = 'payme',
  NUVEI_NEOSURF = 'apmgw_NeoSurf_Direct_Integration_',
  SCALA_PAY = 'scalapay',
  CLEARPAY = 'clearpay',
  UPI = 'upi',
  PAYCO = 'payco',
  KR_CARD = 'kr_card',
  SAMSUNG_PAY = 'samsung_pay',
  NAVER_PAY = 'naver_pay',
  KAKAO_PAY = 'kakao_pay',
  SWISH = 'swish',
  MBWAY = 'mbway',
}
